import { Box, Typography } from '@mui/material';
import { formatCurrency } from '../../../shared/utils/currency';

interface PaymentLineItemRowProps {
  name: string;
  amount: number;
  subtitle?: string;
}

export function PaymentLineItemRow({
  name,
  amount,
  subtitle,
}: PaymentLineItemRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">
        {name}
        {subtitle && (
          <Typography
            component="span"
            variant="caption"
            color="text.secondary"
            sx={{ ml: 1 }}
          >
            ({subtitle})
          </Typography>
        )}
      </Typography>
      <Typography variant="body1" fontWeight="medium" color="success.main">
        {formatCurrency(amount)}
      </Typography>
    </Box>
  );
}
